import {
  FormControlLabel,
  FormControlLabelProps,
  SwitchProps,
  Tooltip,
} from "@mui/material";
import { IOSSwitch } from "./styles";
import { FC } from "react";

interface ISwitchButton extends Omit<FormControlLabelProps, "control"> {
  switchProps?: SwitchProps;
}

const SwitchButton: FC<ISwitchButton> = ({ switchProps, ...props }) => {
  return (
    <Tooltip title={props.disabled ? "We don't support this feature yet" : ""}>
      <FormControlLabel
        {...props}
        control={<IOSSwitch sx={{ m: 1 }} {...switchProps} />}
      />
    </Tooltip>
  );
};

export default SwitchButton;
